function stateWebsites() {

    let body            = $('body');
    let webstites       = $('._js-state-websites-wrapper');
    let websitesLink    = $('._js-state-websites-link');
    let websitesClose   = $('._js-state-websites-close');
    let activeClass     = '_state-websites-opened';
    let bodyWith;

    $(window).on('load resize', function(){
        bodyWith = body.width();
    });

    websitesLink.on('click', function(e){
        e.preventDefault();

        if ( !body.hasClass(activeClass) ) {
            body.addClass(activeClass);
            body.css({
                'max-width' : bodyWith + 'px'
            });
        }
        else {
            body.removeClass(activeClass).removeAttr('style');
        }

    });

    websitesClose.on('click', function(e){
        e.preventDefault();
        if ( body.hasClass(activeClass) ) {
            body.removeClass(activeClass).removeAttr('style');
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (
            !webstites.is(e.target) && webstites.has(e.target).length === 0
                &&
            !websitesLink.is(e.target) && websitesLink.has(e.target).length === 0
        )
        {
            body.removeClass(activeClass).removeAttr('style');
        }
    });

}